module.exports = require("npm:string_decoder@0.10.31/index.js");